<template>
  <section>
    <page-header :title="title">
      <template v-slot:headerIcon>
        <img src="/static/svg/referral.svg" alt="referral icon" />
      </template>
      <template v-slot:headerContent>
        <div class="header-link-container">
          <a :href="historyLink" class="button header-link-button"
            >View History
          </a>
          <span v-if="historyLoaded && referralsCount" class="badge">{{
            referralsCount
          }}</span>
        </div>
      </template>
    </page-header>
    <p>{{ description }}</p>
    <p :style="colorText">
      <strong>Two options:</strong>
    </p>
    <section>
      <h3>1. Share My Referral Link</h3>
      <p class="mt-0">
        Share your page to your friends, family, or social media. Anyone who
        shops and completes the form will count as your referral.
      </p>

      <div class="input-group">
        <input
          type="text"
          name="shareLink"
          id="shareLink"
          :value="shareLink"
          readonly
          disabled
        />
        <button
          class="button"
          :disabled="!shareLink"
          :style="buttonStyles"
          @click="onShare"
        >
          Share
        </button>
      </div>
    </section>
    <section>
      <h3>2. Add Friends Manually</h3>
      <p class="mt-0">
        Add your friend now and send them a personalized link to your referral
        page.
      </p>

      <div class="input-group fx fx-col">
        <div class="u-mb2 fx fx-col">
          <input
            v-model="referral.name"
            type="text"
            name="referralName"
            id="referralName"
            placeholder="First &amp; Last Name"
            v-validate="{ required: true, min: 3, fullName: true }"
          />
          <span class="error-message" v-if="errors.first('referralName')">{{
            errors.first("referralName")
          }}</span>
        </div>

        <vue-tel-input
          class="text-left"
          data-vv-name="Phone"
          v-model="referral.phone"
          :phone="referral.phone"
           v-validate.continues="{ required: true, phone: true }"
          :invalid="errors.first('Phone')"
          name="phone"
        ></vue-tel-input>
        <span v-if="errors.first('Phone')" class="error-message">
          {{errors.first('Phone')}}
        </span>

        <button
          type="button"
          class="button submit-button"
          @click="onNext"
          :style="buttonStyles"
          :disabled="loading || errors.any()"
        >
          Next
        </button>
      </div>
    </section>
    <a class="bottom-link" :href="howItWorksUrl">How does this work?</a>
  </section>
</template>

<script>
import { PAGES } from '@/shared/routes.constants.js'
import { mapState, mapGetters } from 'vuex'
import Loader from '@components/loader.vue'
export default {
  name: 'referral-main',
  props: ['title', 'customization', 'description', 'sharedLinkData', 'loading'],
  components: {
    Loader
  },
  computed: {
    buttonStyles () {
      return {
        'background-color': this.customization.mainColor,
        color: this.customization.fontColor
      }
    },
    colorText () {
      return { color: this.customization.mainColor }
    },
    shareLink () {
      return this.sharedLinkData.link
    },
    ...mapState({
      referralsCount: (state) => {
        return state.recommendFriend.historyCount <= 99
          ? state.recommendFriend.historyCount
          : '+99'
      }
    }),
    ...mapGetters({
      historyLoaded: 'recommendFriend/historyLoaded'
    })
  },
  data () {
    return {
      historyLink: [PAGES.RacommendAFriend, PAGES.Referrals].join('/'),
      howItWorksUrl: [PAGES.RacommendAFriend, PAGES.ReferralHowItWorks].join(
        '/'
      ),
      referral: {
        name: null,
        phone: null
      }
    }
  },
  methods: {
    onShare () {
      this.$emit('share')
    },
    onNext () {
      console.log('submit')
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit('next', {
            referral: this.referral,
            onSuccess: () => this.resetForm()
          })
        }
      })
    },
    resetForm () {
      this.referral.name = null
      this.referral.phone = null
      requestAnimationFrame(() => {
        this.$validator.reset()
      })
    }
  }
}
</script>

<style scoped>
.page_title {
  margin-inline: 0;
  display: inline-flex;
  gap: 5px;
}

.input-group {
  display: flex;
  gap: 4px;
}

.input-group input {
  border: 1px solid rgba(0, 0, 0, 0.2);
  flex-grow: 1;
  transition: border 0.3s ease-in;
  min-height: 40px;
  box-sizing: border-box;
}

.input-group input:disabled {
  background-color: rgba(0, 0, 0, 0.1);
  pointer-events: none;
  border-width: 0;
}

.input-group input:focus {
  border-color: rgba(0, 0, 0, 0.5);
  border-width: 1.5px;
}

.input-group > .button {
  border-radius: 5px;
  min-height: 40px;
  min-width: 80px;
  background-color: rgba(44, 97, 213, 1);
  color: #fff;
}

input[type="text"] {
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 16px;
}

.mt-0 {
  margin-top: 0;
}

section {
  margin-bottom: 32px;
}

.bottom-link {
  font-weight: 600;
  margin-inline: auto;
  display: block;
  text-align: center;
  margin-bottom: 24px;
}

.header-link-container {
  position: relative;
}

.header-link-container > .badge {
  position: absolute;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-pack: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  background-color: rgb(255, 61, 61);
  padding-inline: 4px;
  line-height: 1;
  border-radius: 18px;
  font-size: 14px;
  top: 0px;
  right: -14px;
}

.submit-button {
  margin-top: 24px;
}
</style>
<style>
.input-group .intl-tel-input {
  width: 100%;
}

.intl-tel-input .flag-container {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 2px;
}

.input-group .intl-tel-input input {
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: border 0.3s ease-in;
  min-height: 40px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// referral-main.vue?7bdcf16e